import { Component, Inject, OnInit } from '@angular/core';
import { AppService, AppFeatureService } from '@nk/access-block';
import { AuthInfo, GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { AppIdentityCompositeEntity } from '@nk/data-entities-lib';
import { AppFeatureEntity } from '@nk/data-entities-lib';
import { first, mergeMap } from 'rxjs/operators';

@Component({
  templateUrl: 'identity-view.component.html',
  styles: [
    `
      pre {
        white-space: pre-wrap; /* Since CSS 2.1 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
      }
    `,
  ],
  standalone: false,
})
export class IdentityViewComponent implements OnInit {
  public auth: AuthInfo;
  public identity: AppIdentityCompositeEntity;
  public createdAtISO: string;
  public expiresAtISO: string;
  public appFeatures: AppFeatureEntity[];

  constructor(
    private _appService: AppService,
    private _appFeatureService: AppFeatureService,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public ngOnInit(): void {
    this._authService.authInfo$.subscribe((auth) => {
      this.auth = auth;
      this.createdAtISO = new Date(+this.auth.createdAt).toISOString();
      this.expiresAtISO = new Date(+this.auth.expiresAt).toISOString();
    });
    this._appService.identityDataCache
      .get()
      .pipe(
        mergeMap((identity) => {
          this.identity = identity;
          return this._appFeatureService.appFeatureListByMembershipCache
            .get(identity.app_membership.uuid)
            .pipe(first());
        }),
      )
      .subscribe((features) => {
        this.appFeatures = features;
      });
  }

  public onLogoutClick(): void {
    this._authService.logout('userLogout');
  }

  public onRequestNewAccessToken(): void {
    this._authService.renewToken();
  }
}
